// extracted by mini-css-extract-plugin
export var iconsContainer = "imageText-module--iconsContainer--JGcDr";
export var image = "imageText-module--image--lvF-P";
export var imageWrapper = "imageText-module--imageWrapper--7NK2C";
export var mainImage = "imageText-module--mainImage--itJAJ";
export var right = "imageText-module--right--8TTT8";
export var sbShowMain = "imageText-module--sb-show-main--FhhUL";
export var showIcons = "imageText-module--showIcons--analP";
export var storybook = "imageText-module--storybook--WijMM";
export var textWrapper = "imageText-module--textWrapper--fopFx";
export var wrapper = "imageText-module--wrapper--GQzqw";